// @flow
/*
(c) Copyright European Space Agency, 2023

Project name: THEMIS: Tracking the Health of the Environment and Missions in Space

Description:  MissionPlannedList component for planned missions

Author: Deimos Space UK

Version: 1.0
*/
import React, { useEffect, useState } from "react";
import { Card, CardBody, Table,  Button, Row, Col } from "reactstrap";
import { getPetition } from "../../../../api/api";
import { Link } from "react-router-dom";
import useDebounce from "../../../../hooks/useDebounce";
import { toast } from 'react-toastify';
import {  Form , OverlayTrigger, Tooltip} from 'react-bootstrap';

export default function MissionPlannedList() {
  const [loading, setLoading] = useState(false)
  const [missions, setMissions] = useState([])
  const [nextUrl, setNextUrl] = useState('')
  const [previousUrl, setPreviousUrl] = useState('')
  const [search, setSearch] = useState('')
  const debouncedSearchTerm = useDebounce(search, 1000);



  useEffect(() => {
    if (debouncedSearchTerm) {
     
      getPetition(`/api/missions?draft=true&name=${debouncedSearchTerm}`)
        .then((data) => {
          if (data.missions) {
            setMissions(data.missions)
            setNextUrl(data.next_url)
            setPreviousUrl(data.prev_url)
          }
          else {
            setMissions([])
          }
         
        })
        .catch((error) => {
          toast.warning('No mission found')
         
        })
    }else{
     
      getPetition(`/api/missions?draft=true`)
        .then((data) => {
          if (data.missions) {
            setMissions(data.missions)
            setNextUrl(data.next_url)
            setPreviousUrl(data.prev_url)
          }
          else {
            setMissions([])
          }
          
        })
        .catch((error) => {
          toast.warning('No mission found')
        })
    }
  }, [debouncedSearchTerm])


  useEffect(() => {
    setLoading(true)

    getPetition('/api/missions?draft=true')
      .then((data) => {
        setMissions(data.missions)
        setNextUrl(data.next_url)
        setPreviousUrl(data.prev_url)
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
      })
  }, [])
 const fetchNextData = () => {
    setLoading(true)
    getPetition(nextUrl)
      .then((data) => {
        if (data.missions) {
          setMissions(data.missions)
          setNextUrl(data.next_url)
          setPreviousUrl(data.prev_url)
        }
        else {
          setMissions([])
        }
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
      })
  }

  const fetchPreviousData = () => {
    setLoading(true)
    getPetition(previousUrl)
      .then((data) => {
        if (data.missions) {
          setMissions(data.missions)
          setNextUrl(data.next_url)
          setPreviousUrl(data.prev_url)
        }
        else {
          setMissions([])
        }
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
      })
  }

  const formatDate = (date) => {
    const dateObj = new Date(date)
    const month = dateObj.getMonth() + 1
    const day = dateObj.getDate()
    const year = dateObj.getFullYear()
    return `${day}/${month}/${year}`
  }

const formatCapacity = (capacity) => {
  if(!capacity) return 0  
  // capcity is a long decimal numer transform it to eponential an return it 
  return capacity.toExponential(2)
}

  if (loading) { return (<div>loading...</div>) }
  return (
    <Card>
      <CardBody>
      <Row>
          <Col md={8}>
        <h4 style={{ color: '#003247' }} className="header-title">MISSION LIST</h4>
        </Col>
        <Col md={4}>
        <Form.Control
              placeholder="Search by mission name"
              style={{ marginBottom: '10px' }}
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
        </Col>
        </Row>
        <Table className="mb-0">
          <thead>
            <tr>
              <th style={{ color: '#003247' }} >Id</th>
              <th style={{ color: '#003247' }} >Mission</th>
              <th style={{ color: '#003247' }} >Launch date</th>
              <th style={{justifyContent: 'center', alignItems:'center', color: '#003247'}} >Total minimum capacity</th>
              <th style={{  justifyContent: 'center', alignItems:'center',color: '#003247' }} >Total maximum capacity</th>
              <th style={{ color: '#003247' }}> Version </th>
              <th style={{  justifyContent: 'center', alignItems:'center',color: '#003247'}} > Actions</th>
            </tr>
          </thead>
          <tbody>
            {missions.map((record, index) => {
              return (
                <tr key={index}>
                  <td>{record.id}</td>
                  <td>{record.name}</td>
                  <td>{formatDate(record.launch_date)}</td>
                  <td style={{  justifyContent: 'center', alignItems:'center',  }}>{formatCapacity(record.total_minimum_capacity)}</td>
                  <td style={{ justifyContent: 'center', alignItems:'center',  }}>{formatCapacity(record.total_maximum_capacity)}</td>
                  <td>{record.version}</td>
                  <td className="table-action" style={{ width: "90px" }}>
                    <Link className="action-icon" to={`/impact-evaluation/clone/${record.id}`}>
                    <OverlayTrigger
                      key={'right'}
                      placement={'left'}
                      overlay={
                        <Tooltip id={`tooltip-right`}>
                          Edit mission
                        </Tooltip>
                      }>
                      <i className="dripicons-pencil"></i>
                    </OverlayTrigger>
                    </Link>
                    <Link className="action-icon" to={`/mission-detail/${record.id}`}>
                    <OverlayTrigger
                      key={'right'}
                      placement={'left'}
                      overlay={
                        <Tooltip id={`tooltip-right`}>
                          Mission detail
                        </Tooltip>
                      }>
                      <i className=" dripicons-search"></i>
                    </OverlayTrigger>
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        <div style={{ paddingTop: '20px', paddingBottom: '20px', display: 'flex', gap: '10px' }}>
            <Button style={{ background: '#003247', borderColor: '#003247' }} disabled={previousUrl===null } onClick={()=>fetchPreviousData()}>
              Previous
            </Button>
            <Button style={{ background: '#003247', borderColor: '#003247' }} onClick={()=>fetchNextData()} >
              Next
            </Button>
          </div>
       
      </CardBody>
    </Card>
  );
}
